module.exports = __webpack_public_path__ + "assets/img/avatar-8.35dab8da.jpg";